import { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

extend(utc);
extend(timezone);

export { default } from 'dayjs';
